module.exports = __webpack_public_path__ + "img/f1-3.0a7673f3.png";